import { scrollToY } from './scrollToY';

export function pagePreload(callback) {

    const hash = window.location.hash;
    const elementToSliding = hash ? document.getElementById(hash) : null;

    setTimeout(() => {
        callback();
        document.body.classList.remove('preload');

        if (elementToSliding) {
            const y = elementToSliding.getBoundingClientRect().top + (window.scrollY || document.body.scrollTop);

            scrollToY(y);
        }
    }, 800);

}